module.exports = __webpack_public_path__ + "static/media/34077364-preview.711cf17a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/34077364-preview.mp4
// module id = 1817
// module chunks = 0